module.exports = __webpack_public_path__ + "static/media/ui-icons-menus-on.e28747a2.svg";